var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-tables"},_vm._l((_vm.seperatedFeatureData),function(featureTable,propertyName){return _c('div',{key:`item_${propertyName}`,staticClass:"feature-table",style:(_vm.paperSizeStyle)},[_c('h1',[_vm._v(_vm._s(featureTable.title))]),_c('b-table',{attrs:{"items":featureTable.data,"fields":featureTable.fields}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }